import { graphql, useStaticQuery } from 'gatsby'

export const useContactInfo = () => {
  const { wp } = useStaticQuery<Queries.useContactInfoQueryQuery>(graphql`
    query useContactInfoQuery {
      wp {
        acfOptionsKontaktniUdaje {
          contactInfo {
            basicContact {
              email
              phone
            }
            companyInfo {
              companyName
              businessId
              taxId
              registryNotice
            }
            socialNetworks {
              socialNetworkType
              profileLink
            }
            address {
              address1
              address2
              city
              postalCode
              navigationLink
            }
          }
        }
      }
    }
  `)

  return {
    basicContact: wp?.acfOptionsKontaktniUdaje?.contactInfo?.basicContact,
    companyInfo: wp?.acfOptionsKontaktniUdaje?.contactInfo?.companyInfo,
    socialNetworks: wp?.acfOptionsKontaktniUdaje?.contactInfo?.socialNetworks,
    address: wp?.acfOptionsKontaktniUdaje?.contactInfo?.address,
  }
}
